import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function initCalendarSlider(): void {
  document.querySelectorAll('.calendar-slider').forEach((holder) => {
    const swiper = holder.querySelector('.swiper');
    if (swiper) {
      const navNext = holder.querySelector('.swiper-button-next');
      const navPrev = holder.querySelector('.swiper-button-prev');
      // eslint-disable-next-line no-new
      new Swiper(swiper as HTMLElement, {
        modules: [Navigation, Pagination],
        loop: true,
        grabCursor: true,
        slidesPerView: 1,
        navigation: {
          nextEl: navNext as HTMLElement | null,
          prevEl: navPrev as HTMLElement | null,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          992: {
            slidesPerView: 2,
          },
        },
      });
    }
  });
}
